import HeartHandImage from 'src/assets/svg/landing/heart-hand.svg';

export const MadeNotManufactured = () => (
  <div className='flex-col bg-eggplant-50 px-8 pb-0 text-center text-eggplant-600 md:py-28 '>
    <img src={HeartHandImage} alt='Made, not manufactured' className='mb-3.5 inline-block' />
    <h3 className='pb-3.5 font-juniper-bay text-8xl'>MADE,</h3>
    <h3 className='text-4xl font-bold md:text-6xl'>NOT</h3>
    <h3 className='text-4xl font-bold md:text-6xl'> MANUFACTURED </h3>
  </div>
);
